
import { FunnelsServices } from "@/services";
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      locationId: "",
      funnelId: "",
      type: "funnel",
      loading: false,
      errMsg: ""
    };
  },
  methods: {
    async switchType() {
      try {
        if (!this.locationId || !this.funnelId) {
          throw new Error("Missing required fields");
        }
        this.errMsg = "";
        this.loading = true;
        await FunnelsServices.switchFunnelType({
          locationId: this.locationId,
          funnelId: this.funnelId,
          type: this.type
        });
        this.loading = false;
      } catch (error: any) {
        console.error(error);
        if (error && error.request) this.errMsg = JSON.parse(error.request.response).message;
        this.loading = false;
      }
    }
  }
});
